import { signOut } from "firebase/auth";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect } from "react";
import { authService, firestoreService } from "../../firebase-config";

export function useWatchUserSessions() {
  useEffect(() => {
    const unsubscribeAuth = authService.onAuthStateChanged((user) => {
      if (!user) return;

      const q = query(
        collection(firestoreService, "sessions"),
        where("userId", "==", user.uid)
      );

      const unsubscribeSessions = onSnapshot(q, async (snapshot) => {
        try {
          await user.getIdToken(true);
        } catch (err: any) {
          console.warn("🔴 Token inválido o revocado:", err.code);

          if (
            err.code === "auth/id-token-revoked" ||
            err.code === "auth/user-disabled"
          ) {
            await signOut(authService);
          }
        }

        snapshot.docChanges().forEach(async (change) => {
          if (change.type === "modified") {
            const data = change.doc.data();
            if (data.isActive === false) {
              await signOut(authService);
            }
          }
        });
      });

      return () => unsubscribeSessions();
    });

    return () => unsubscribeAuth();
  }, []);
}
